import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {AgentService} from "app/services";
import {errorMsg, successMsg} from "app/utils/MessageUtils";
import {UpdateAgentBodyTypes} from "app/types/service-types/AgentTypes";
import {fetchAllAgents, fetchAllSubAgents} from "./agents-list.slice";
import AuthService from "app/services/auth.service";
import {ROLES} from "app/constants/roles";

interface UpdateAgentStateParams {
  id: string;
  body: UpdateAgentBodyTypes;
  onSuccess?: Function;
  onError?: Function;
}

const isUserAgent = (): boolean => {
  const user = AuthService.handleAuthentication();
  if (!user) return false;
  // @ts-ignore
  const authorities = user.authorities || [];
  const isAdmin = authorities.includes(ROLES.ROLE_ADMIN);
  const isAgent = authorities.includes(ROLES.ROLE_AGENT) && !isAdmin;
  return isAgent;
};

export const updateAgent = (params: UpdateAgentStateParams) => async (dispatch: Dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await AgentService.updateAgent(params.id, params.body);
    if (response.status >= 200 && response.status < 300) {
      dispatch(setSuccess(true));
      const userIsAgent = isUserAgent();
      const lang = localStorage.getItem('i18nextLng');
      const message = lang === 'en' 
        ? (userIsAgent ? 'Sub-Agent changed successfully!' : 'Agent changed successfully!')
        : (userIsAgent ? 'Sub-Agjenti u ndryshua me sukses!' : 'Agenti u ndryshua me sukses!');
      dispatch(successMsg(message));
      if (params.onSuccess) params.onSuccess();
      dispatch(setError(""));
      // @ts-ignore
      dispatch(userIsAgent ? fetchAllSubAgents() : fetchAllAgents());
    }
    dispatch(setLoading(false));
  } catch (err) {
    dispatch(setLoading(false));
    dispatch(errorMsg(err.data.message));
    if (params.onError) params.onError();
    dispatch(setError(err.data.message));
  }
};

interface UpdateAgentSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: UpdateAgentSlice = {
  error: "",
  success: false,
  loading: false,
};

const stateSlice = createSlice({
  name: "agent/update-agent",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;
